/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	HttpClient
} from '@angular/common/http';
import {
	Inject,
	Injectable
} from '@angular/core';
import {
	IRuleValidatorDefinitionDto
} from '@api/interfaces/rules/rule-validator-definition.dto.interface';
import {
	BaseEntityApiService
} from '@api/services/base/base-entity.api.service';
import {
	AppConstants
} from '@shared/constants/app.constants';
import {
	CacheService
} from '@shared/services/cache.service';

/**
 * A class representing the logic and services of the rule validator
 * definition controller.
 *
 * @export
 * @class RuleValidatorDefinitionApiService
 * @extends {BaseEntityApiService<IRuleValidatorDefinitionDto>}
 */
@Injectable()
export class RuleValidatorDefinitionApiService
	extends BaseEntityApiService<IRuleValidatorDefinitionDto>
{
	/**
	 * Creates an instance of a RuleValidatorDefinitionApiService.
	 *
	 * @param {HttpClient} HttpClient
	 * The injected http client to use in the base api service.
	 * @param {CacheService} cache
	 * The injected cache service to use in the base api service.
	 * @memberof RuleValidatorDefinitionApiService
	 */
	public constructor(
		@Inject(HttpClient) http: HttpClient,
		@Inject(CacheService) cache: CacheService)
	{
		super();
		this.httpClient = http;
		this.cacheService = cache;
		this.endpoint =
			AppConstants.apiControllers.ruleValidatorDefinitions;
	}
}